module.exports = __webpack_public_path__ + "static/media/bg1.0d535fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/bg1.png
// module id = 1053
// module chunks = 0